<template>
  <router-view />
</template>

<script>
export default {
  name: 'BasicRouterContainer',
}
</script>
